import request from '@/utils/request'


// 查询商品问答列表
export function listQuestion(query) {
  return request({
    url: '/biz/admin/goods/question/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品问答分页
export function pageQuestion(query) {
  return request({
    url: '/biz/admin/goods/question/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品问答详细
export function getQuestion(data) {
  return request({
    url: '/biz/admin/goods/question/detail',
    method: 'get',
    params: data
  })
}

// 新增商品问答
export function addQuestion(data) {
  return request({
    url: '/biz/admin/goods/question/add',
    method: 'post',
    data: data
  })
}

// 修改商品问答
export function updateQuestion(data) {
  return request({
    url: '/biz/admin/goods/question/edit',
    method: 'post',
    data: data
  })
}

// 删除商品问答
export function delQuestion(data) {
  return request({
    url: '/biz/admin/goods/question/delete',
    method: 'post',
    data: data
  })
}
